import { gql } from "gql";
import { ProductOffer, ProductOffersContext } from "gql/graphql";
import { getActiveUser } from "@noom/hive-auth";
import { apolloClient } from "src/api/apolloClient";

export const PRODUCT_OFFERS_QUERY = gql(`
  query ProductOffers($input: ProductOffersInput!) {
    productOffers(input: $input) {
      offers {
        productName
        purchaseType
        orderOperation {
          ... on PurchaseOperation {
            saleItemId
            trialSaleItemId
            promoCode
          }
          ... on SwitchOperation {
            saleItemId
            trialSaleItemId
            promoCode
            subscriptionModificationReason
            shippingAddressId
            supplementaryInfo {
              multiUserInfos {
                additionalUserEmail
                additionalName
              }
            }
            switchType {
              ... on ImmediateSwitch {
                billingCycleBehavior
                prorationBehavior
                trialType
              }
              ... on NextBillingCycleSwitch {
                revertBehavior
              }
            }
          }
        }
      }
    }
  }
`);

export async function getProductOffers(
  context?: ProductOffersContext
): Promise<ProductOffer[]> {
  const accessCode = getActiveUser()?.accessCode;

  const result = await apolloClient.query({
    query: PRODUCT_OFFERS_QUERY,
    variables: {
      input: { accessCode, context },
    },
    fetchPolicy: "no-cache",
  });

  return result.data.productOffers.offers;
}
